/**
 * Настройки кэша react-query для запросов к /api/programs/.
 *
 * QueryClient теперь задаёт refetchOnMount/WindowFocus/Reconnect: false
 * (раньше опция была с опечаткой `refetchOnmount` и не действовала).
 * Состав программ за сервисный период меняется редко, поэтому держим ответ
 * свежим 5 минут и не выбрасываем из кэша 30 минут.
 */
export const PROGRAMS_STALE_TIME = 5 * 60 * 1000;

export const PROGRAMS_CACHE_TIME = 30 * 60 * 1000;
